var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profilepage"},[_c('v-main',[_c('v-container',{staticClass:"ma-0 pa-0"},[_c('MainProfile'),_c('MainDivider'),_c('ContentList',{attrs:{"searchVal":_vm.searchVal}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }